<div class="container">
    @if (showSelectAll) {
        <div class="checkBox" aria-label="Baumstruktur alle aus-/abwählen">
            <p-checkbox
                role="checkbox"
                [ngModel]="summarySelectedState === true"
                [indeterminate]="summarySelectedState === false"
                (onChange)="onCheckBoxChanged($event)"
                [binary]="true"
                [attr.aria-label]="'Alle'"
                [attr.aria-checked]="summarySelectedState"
            ></p-checkbox>
            <label class="checkbox-label">Alle</label>
        </div>
    }
    @if (!isLoading) {
        <div id="treeLabel" class="h-offscreen">Archivablage-Baum</div>
        <p-tree
            [value]="filteredList"
            selectionMode="checkbox"
            ariaLabelledBy="treeLabel"
            [(selection)]="selectedNodes"
            (onNodeUnselect)="anyNodeChange()"
            (onNodeSelect)="anyNodeChange()"
            [styleClass]="'my-tree'"
            emptyMessage="Keine Einträge gefunden"
            scrollHeight="{{ 'var(--tree-scroll-height)' }}"
        ></p-tree>
    } @else {
        <div class="loading-tree">
            <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
        </div>
    }
</div>
